import React, { useEffect } from "react";
import './Feeds.css'

const Feeds = () => {
    const clickEvent = () => {
        window.open("https://www.google.com/search?sca_esv=579f82cacf11448d&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzS9hGq7ZUVE1yK6K9M5kUnuNfk9AhYdsYvHONVq_QJHIC2GoDCLenpFzTq3mNrlqAzXki0GUHjbURo1CGSWJ8R0Edncl&q=MV+Nails+House+Reviews&sa=X&ved=2ahUKEwjjvovctcqLAxWF8DgGHVo4GnUQ0bkNegQIIBAD&biw=1920&bih=897&dpr=1")
    }

    useEffect(() => {
        // window.scrollTo(0, 0);
    }, [])

    return (
        <section className="page-section" id="services" style={{ background: "transparent", backgroundImage: "linear-gradient(180deg, #D7D7D7 0%, #D7D7D7 100%)", userSelect: "none" }}>
            <div className="container">
                <div className="col-md-12 textEffect text-black d-flex flex-column gap-3">
                    <span className="fs-2 fw-bold text-center text-md-center">
                        Customer Testimonials
                    </span>
                </div>
                {/* Responsive carousel container */}
                <div className="testimonials-container mb-2">
                    <div className="testimonials-wrapper">
                        <div className="card">
                            <div className="quote">“</div>
                            <p className="testimonial-text">
                                The best artist with the best art...so creative and absolutely amazing❤💅.
                            </p>
                            <div className="testimonial-name">- Vaishali Patel</div>
                        </div>
                        <div className="card">
                            <div className="quote">“</div>
                            <p className="testimonial-text">
                            I got too many complaints on my nails ur desgin nd her finish is on top 🫶🏻just loved her work must visit Mv nails house!
                            </p>
                            <div className="testimonial-name">- Swati Thakkar</div>
                        </div>
                        <div className="card">
                            <div className="quote">“</div>
                            <p className="testimonial-text">
                                Amazing nail art, she’s very talented👍🏻
                            </p>
                            <div className="testimonial-name">- Evanshi</div>
                        </div>
                    </div>
                </div>
                {/* Dotted Scroll Indicators */}
                {/* <div className="dots">
                    <span className="dot active"></span>
                    <span className="dot"></span>
                    <span className="dot"></span>
                </div> */}
                <div className="text-center">
                    <button
                        className="btn btn-secondary btn-sm text-uppercase"
                        onClick={clickEvent}
                    >
                        View More
                    </button>
                </div>
            </div>
        </section>

    )
}

export default Feeds;